import { makeAutoObservable } from "mobx";

export default class UserStore {
  constructor(clinicStore) {
    this._isAuth = false;
    this._user = {};
    this.clinicStore = clinicStore;
    makeAutoObservable(this);
  }

  setUser(user) {
    this._user = {...this._user,...user};
  }

  setIsAuth(bool) {
    this._isAuth = bool;
  }

  async loadClinicData() {
    try {
      const clinicData = await this.clinicStore.getClinic();
      this.clinicStore.setClinicData(clinicData);
    } catch (error) {
      console.error("Ошибка при загрузке данных о клинике:", error);
    }
  }

  get isOwner() {
    return this._user.access.isOwner;
  }

  get access() {
    return this._user.access;
  }

  get user() {
    return this._user;
  }

  get isAuth() {
    return this._isAuth;
  }
}